import CryptoJS from "crypto-js";
import { ENVIRONMENT } from "../config/buildConfig";

const PASSWORD_ENCRYPT_KEY = 
     ENVIRONMENT === "PRODUCTION"
    ? "5fc568358326d3ac78bda77cf07fa0a607d525de67f9504f4440ed1975e1a35694ffc9d37c2a00f12f161bd16e8fa82df37534a6b69692330b296d0f8bdc86c0"
    : "4c014baf9ceb8df997f385851564f92d7c46553689908409ae92df50fb634fd882e617c61210f0422c939cc9324b35d126a6dfa795b56eb2aee0dea25e380d84";

export function decrypt(encrypted) {
  if (!encrypted) return "";
  const decryptData = CryptoJS.AES.decrypt(encrypted, PASSWORD_ENCRYPT_KEY);
  const decryptPwd = decryptData.toString(CryptoJS.enc.Utf8);
  // console.log({ decryptPwd });
  return decryptPwd;
}
